// A session's recording, played in the page (TX-US-0028).
//
// The URL is signed and short-lived, so it is fetched when the BD asks to listen and not before:
// a history of twenty sessions is then no request until one of them is played.

import { useState } from 'react';

import { getHubRecordingDownload } from '../api.js';
import Icon from '../ui/Icon.jsx';
import { formatElapsed } from './recorder.js';

export default function RecordingPlayer({ sessionId, recording }) {
  const [source, setSource] = useState(null);
  const [error, setError] = useState(null);

  const length = recording.duration_seconds
    ? formatElapsed(recording.duration_seconds * 1000)
    : null;

  const play = () => getHubRecordingDownload(sessionId)
    .then((found) => setSource(found.download_url))
    .catch((err) => setError(err.message));

  if (source) {
    // The recording itself is the caption-less content; there is no transcript in this story.
    return <audio className="hub-audio" src={source} controls autoPlay aria-label="Recording" />;
  }

  return (
    <>
      <button type="button" className="hub-play" onClick={play}>
        <Icon name="play" />
        <span>Play recording{length && ` · ${length}`}</span>
      </button>
      {error && <p className="error">{error}</p>}
    </>
  );
}
